import React, { Component } from 'react';
import glamorous from 'glamorous';
import Dropzone from 'react-dropzone';
import Panel from 'react-bootstrap/lib/Panel';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { injectIntl, FormattedMessage } from 'react-intl';
import { filter, map, isEmpty, get, isString, reduce, includes } from 'lodash';
import messages from '../../utils/messages';
import { getConfig } from '../../selectors';
import { Link } from '../../views/visions/vx-link';
import * as selectors from '../../selectors';

const StyledPanel = glamorous(Panel)({
  marginTop: 10
});

const FileItemStatus = (props) => {
  const { fileName, status } = props;
  return (
    <tr>
      <glamorous.Td css={{ width: '20%' }}>
        <strong>
          {fileName}
        </strong>
      </glamorous.Td>
      <glamorous.Td css={{ verticalAlign: 'middle !important' }}>
        {status.response || JSON.stringify(status.error)}
      </glamorous.Td>
    </tr>
  );
};

const UploadStatus = ({ uploadState, onClose }) => {
  return (
    <StyledPanel bsStyle="primary">
      <Panel.Heading>
        <glamorous.H3 className="panel-title" css={{ display: 'inline' }}>
          <FormattedMessage id="admin.uploadStatus"/>
        </glamorous.H3>
        <glamorous.Span
          className="pull-right"
          css={{
            cursor: 'pointer',
            color: '#fff'
          }}
          onClick={e => onClose()}
        >
          x
        </glamorous.Span>
      </Panel.Heading>
      <Panel.Body>
        <table className="table table-hover table-bordered">
          <tbody>
          {map(uploadState, (status, fileName) => (
            <FileItemStatus
              key={fileName}
              fileName={fileName}
              status={status}
            />
          ))}
          </tbody>
        </table>
      </Panel.Body>
      <Panel.Footer className="text-right">
        <glamorous.A
          className="pt-button pt-minimal pt-icon-delete"
          onClick={e => onClose()}>
          close
        </glamorous.A>
      </Panel.Footer>
    </StyledPanel>
  );
};

const UploadDropzone = ({ files, onDrop, onFileRemove, onClearAllFiles, onUpload, isUploadDisabled }) => {
  return (
    <Dropzone
      accept="application/zip, application/x-zip-compressed"
      onDrop={onDrop}
      className="pt-card pt-interactive pt-elevation-0"
      activeClassName="pt-card pt-elevation-3"
      multiple
    >
      <h5>
        <a>
          <FormattedMessage id="admin.dropboxTitle"/>
        </a>
      </h5>
      {isEmpty(files) &&
      <em className="text-muted">
        <FormattedMessage id="admin.dropboxDescription"/>
      </em>}
      <div>
        {map(files, f => (
          <div
            key={f.name}
            className="pt-tag pt-tag-removable pt-large pt-intent-primary"
            style={{
              marginRight: 5,
              marginBottom: 5,
            }}
          >
            {f.name} ({formatBytes(f.size)})
            <button
              type="button"
              className="pt-tag-remove"
              onClick={e => {
                e.stopPropagation();
                onFileRemove(f);
              }}
            />
          </div>

        ))}
      </div>
      <div className="text-right">
        {!isEmpty(files) &&
        <glamorous.A
          css={{ marginRight: 15 }}
          className="pt-button pt-minimal pt-icon-delete"
          onClick={e => {
            e.stopPropagation();
            onClearAllFiles();
          }}>
          <FormattedMessage id="admin.clearSelected"/>
        </glamorous.A>}
        <button
          type="button"
          className="pt-button pt-icon-upload pt-intent-primary"
          disabled={isUploadDisabled}
          onClick={e => {
            e.stopPropagation();
            onUpload();
          }}
        >
          <FormattedMessage id="admin.upload"/>
        </button>
      </div>
    </Dropzone>
  );
};

class RecallImports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      files: [],
      apiKey: '',
      uploadState: {},
    };

    this.onDrop = this.onDrop.bind(this);
    this.onUpload = this.onUpload.bind(this);
  }

  onDrop(files) {
    const newFileNames = map(files, 'name');
    const stateFilesToLeave = filter(this.state.files, x => !includes(newFileNames, x.name));
    this.setState({
      files: [...files, ...stateFilesToLeave]
    });
  }

  onUpload() {
    this.setState({ uploadState: {} });

    this.state.files.forEach(file => {
      const fetchOptions = {
        method: 'POST',
        mode: 'cors',
        body: file,
      };
      return fetch(`${this.props.config.api}/import.xqy?apikey=${this.state.apiKey}`, fetchOptions)
        .then(res => isString(res) ? res : res.text())
        .then(response => this.setState({
          uploadState: {
            ...this.state.uploadState,
            [file.name]: { response }
          }
        }))
        .catch(error => {
          this.setState({
            uploadState: {
              ...this.state.uploadState,
              [file.name]: { error: `${error}` }
            }
          })
        })
    });
  }

  render() {
    const { intl: { formatMessage }, config } = this.props;
    return (
      <div>
        <h1>
          <FormattedMessage id="admin.recallImportsTitle"/>
          <glamorous.Span
            css={{ fontSize: 18, position: 'absolute' }}
            title={formatMessage(messages.adminImportDocumentation)}
          >
            <Link
              to="admin/import-documentation"
              target="_blank"
            >
              <i className="glyphicon glyphicon-info-sign"/>
            </Link>
          </glamorous.Span>
        </h1>
        <glamorous.Div css={{ marginTop: 15 }}>
          {isEmpty(this.state.uploadState) &&
          <div className="form-group">
            <label htmlFor="apiKeyInput">
              <FormattedMessage id="admin.apiKey"/>*
            </label>
            <input
              type="password"
              autoComplete="off"
              className="form-control"
              id="apiKeyInput"
              placeholder={formatMessage(messages.apiKeyPlaceholder)}
              value={this.state.apiKey}
              onChange={e => this.setState({ apiKey: e.target.value })}
            />
          </div>}
          {isEmpty(this.state.uploadState) &&
          <UploadDropzone
            files={this.state.files}
            onDrop={this.onDrop}
            onUpload={this.onUpload}
            isUploadDisabled={this.state.files.length < 1 || isEmpty(this.state.apiKey)}
            onFileRemove={(f) => this.setState({
              files: filter(this.state.files, x => x !== f),
            })}
            onClearAllFiles={() => this.setState({ files: [] })}
          />
          }
          {!isEmpty(this.state.uploadState) &&
          <UploadStatus
            uploadState={this.state.uploadState}
            onClose={() => this.setState({ uploadState: {}, files: [] })}
          />}
        </glamorous.Div>
        <glamorous.Div css={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: 20,
          backgroundColor: '#f7f7f9',
          border: '1px solid #e1e1e8',
          padding: '9px 14px',
          borderRadius: '4px',
          justifyContent: 'space-around',
        }}>
          <Link to="admin/import-documentation" target="_blank">
            <FormattedMessage id="admin.importDocumentation"/>
          </Link>
          <a href={`${config.api}/getproductstaxonomy.xqy?format=rdfxml`} target="_blank">
            <FormattedMessage id="admin.taxonomyDownload"/>
          </a>
          <a href={`${config.api}/export.xqy`} target="_blank">
            <FormattedMessage id="admin.exportAPI"/>
          </a>
        </glamorous.Div>
      </div>
    );
  }
}

export default compose(
  injectIntl,
  connect(
    state => ({
      config: selectors.getConfig(state),
    })
  ),
)(RecallImports);

function formatBytes(a, b) {
  if (0 == a) return "0 Bytes";
  var c = 1024, d = b || 2, e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    f = Math.floor(Math.log(a) / Math.log(c));
  return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f]
}



// WEBPACK FOOTER //
// ./src/containers/admin/imports.js